import { useParams } from "react-router-dom";
import { LoadingIndicator } from "../../../../../../components";
import { Title } from "../../../../../../components/dynamicanalysis";
import {
  JoeProcessDetails,
  JoeProcessTreeItem,
  ProcessTreeItem
} from "../../../../@types";
import {
  BehaviorProvider,
  ProcessDetailsGrid,
  ProcessTreeContainer,
  ProcessTreeError
} from "../../../common/dynamicanalysis";
import useGetBehaviorGraph from "../../hooks/useGetBehaviorGraph";
import useGetProcessTree from "../../hooks/useGetProcessTree";
import BehaviorGraph from "./BehaviorGraph";
import { schema } from "./schema/processTreeItem";

const mapJoeProcessTree = (
  processtree: JoeProcessTreeItem[]
): ProcessTreeItem[] =>
  processtree.map(item => ({
    process_id: Number(item["@pid"]),
    parent_process_id: Number(item["@parentpid"]),
    name: item["@name"],
    parameters: item["@cmdline"],
    children: mapJoeProcessTree(item.process ?? [])
  }));

const Behavior = () => {
  const { hash, uploadId } = useParams();

  const { data: processTreeData, isLoading: isProcessTreeLoading } =
    useGetProcessTree(hash, uploadId);
  const { items: behaviorGraphItems, isLoading: isBehaviorGraphLoading } =
    useGetBehaviorGraph(hash, uploadId);

  if (isProcessTreeLoading || isBehaviorGraphLoading) {
    return <LoadingIndicator data-testid="behavior-loading-indicator" />;
  }

  if (!processTreeData || !processTreeData.processtree) {
    return (
      <ProcessTreeError
        analysis="Joe"
        displayStatus={processTreeData?.display_status}
      />
    );
  }

  const processtree = mapJoeProcessTree(processTreeData?.processtree ?? []);

  return (
    <BehaviorProvider>
      <section>
        <Title headingLevel="h2" title="Behavioral Analysis" />
        <ProcessTreeContainer data={processtree} showAdditionalInfo={false} />
        <BehaviorGraph data={behaviorGraphItems} />
        <br />
        <ProcessDetailsGrid<JoeProcessDetails> analysis="joe" schema={schema} />
      </section>
    </BehaviorProvider>
  );
};

export default Behavior;
